import ContentAdd from '@mui/icons-material/Add';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { useUserEntityPermissionsFieldArray } from 'shared/widgets/UserEntityPermissionsDialog/hooks/useUserEntityPermissionsFieldArray';
import { UserEntityPermissionsNames } from 'types/embedded/userEntityPermission';

import { StyledTextField } from './UserEntityPermissionsDialogForm.styled';
import { UserEntityPermissionsDialogFormPermission } from './UserEntityPermissionsDialogFormPermission';

type Props = {
  recordName: string;
  recordId: string;
  entityName: UserEntityPermissionsNames;
};

export const UserEntityPermissionsDialogForm: React.FC<Props> = ({
  recordName,
  recordId,
  entityName,
}) => {
  const { fields, onAddField, onRemoveField } = useUserEntityPermissionsFieldArray(
    recordId,
    entityName,
  );
  const translate = useTypedTranslate();

  return (
    <Box>
      <StyledTextField
        defaultValue={recordName}
        disabled
        label={translate('app.table.name')}
        size="small"
        variant="outlined"
      />
      {fields.map((field, index) => (
        <UserEntityPermissionsDialogFormPermission
          id={field.id}
          index={index}
          key={index}
          onRemoveField={onRemoveField}
        />
      ))}
      <Button
        label={translate('app.merchants.addAccess')}
        onClick={onAddField}
        startIcon={<ContentAdd />}
        variant="outlined"
      />
    </Box>
  );
};
